export default (html: string) => {
    return html
        .replace(/<[^>]+>/g, " ")
        .replace(/\s\s+/g, " ")
        .trim();
};
